import { render, staticRenderFns } from "./AvgProductList.vue?vue&type=template&id=2d85d7bf&"
import script from "./AvgProductList.vue?vue&type=script&lang=js&"
export * from "./AvgProductList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports